import { useT } from '@/store';
import { Modal } from '@/components/ui/Overlay';
import { OrderFormFields } from '@/components/orders/OrderForm';
import { useOrderForm } from '@/hooks/useOrderForm';

/**
 * The dispatcher's fast path: create and send a job without leaving the map.
 * Same form and same validation as the Orders tab's drawer — see
 * OrderForm.jsx — differing only in chrome and in closing on success, since
 * the point here is to get back to the map.
 */
export function QuickDispatchModal({ open, onClose }) {
  const t = useT();
  const form = useOrderForm({ onCreated: () => onClose?.() });

  // V-289. This component never unmounts between opens (see useOrderForm.js's
  // own comment) — every dismissal must clear the form, not just a
  // successful create, or the NEXT open reappears pre-filled with a
  // previous, unrelated order's values and error.
  const close = () => {
    form.reset();
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onClose={close}
      title={t('orders.newOrder')}
      footer={
        <>
          <button type="button" className="btn" onClick={close}>
            {t('common.cancel')}
          </button>
          <button type="button" className="btn btn-primary" onClick={form.submit} disabled={form.isPending}>
            {t(form.isPending ? 'common.loading' : 'orders.createBtn')}
          </button>
        </>
      }
    >
      <OrderFormFields values={form.values} set={form.set} setValue={form.setValue} />
      {form.errorText ? (
        <p className="mt-3 text-[11.5px] text-red" role="alert">
          {form.errorText}
        </p>
      ) : null}
    </Modal>
  );
}
